import { createStyles, makeStyles } from '@hawkins/styles';
export var BASE_CHIP_HEIGHT = 'size3';
export var COMPACT_CHIP_HEIGHT = 'size2';
var generateThemeVariables = function (theme) {
    var hawkins = theme.hawkins;
    if (hawkins.theme === 'light') {
        return {
            background: hawkins.ui.backgroundColor3,
        };
    }
    return {
        background: hawkins.ui.backgroundColor4,
    };
};
export function chipStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    var themeVariables = generateThemeVariables(theme);
    return createStyles({
        /** Class name applied to the root of the component */
        root: {
            alignItems: 'center',
            backgroundColor: themeVariables.background,
            borderColor: hawkinsVariables.colors.transparent,
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            borderStyle: 'solid',
            borderWidth: 1,
            color: hawkins.textColor.textColorRegular,
            display: 'inline-grid',
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontSize: hawkinsVariables.fontSizes.fontSize2,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
            gridTemplateColumns: '1fr',
            height: hawkinsVariables.sizings[BASE_CHIP_HEIGHT],
            gap: hawkinsVariables.spacings.space0,
            justifyItems: 'center',
            paddingLeft: hawkinsVariables.spacings.space1,
            paddingRight: hawkinsVariables.spacings.space1,
        },
        /** Class name applied to the component when `compact` is true */
        compact: {
            height: hawkinsVariables.sizings[COMPACT_CHIP_HEIGHT],
            fontSize: hawkinsVariables.fontSizes.fontSize0,
        },
        /** @private */
        withStartAdornment: {
            gridTemplateColumns: 'max-content 1fr',
            paddingLeft: hawkinsVariables.spacings.space0,
        },
        /** @private */
        withEndAdornment: {
            gridTemplateColumns: '1fr max-content',
            paddingRight: hawkinsVariables.spacings.space0,
        },
        /** @private */
        withStartAndEndAdornment: {
            gridTemplateColumns: 'max-content 1fr max-content',
            paddingLeft: hawkinsVariables.spacings.space0,
            paddingRight: hawkinsVariables.spacings.space0,
        },
        /** Class name applied to the label of the component */
        label: {
            gridColumn: 1,
            width: '100%',
        },
        /** @private */
        labelWithStartAdornment: {
            gridColumn: 2,
        },
        /** @private */
        labelWithEndAdornment: {
            gridColumn: 1,
        },
        /** @private */
        labelWithStartAndEndAdornment: {
            gridColumn: 2,
        },
        /** Class name applied to the `startAdornment` section of the component */
        startAdornment: {
            gridColumn: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        /** Class name applied to the `endAdornment` section of the component */
        endAdornment: {
            gridColumn: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
}
export var useChipStyles = makeStyles(chipStyles, { name: 'Hawkins-Chip' });
